var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "chat-style-comment-linked-blog-answer" }, [
    _c(
      "span",
      {
        staticClass: "chat-style-comment-linked-blog-answer__text",
        class: {
          "chat-style-comment-linked-blog-answer__text_white":
            _vm.moveAvatarToRight,
        },
      },
      [
        _c(
          "strong",
          [_c("simple-link", { attrs: { target: _vm.comment.userprofile } })],
          1
        ),
        _vm._v(" has linked\n        "),
        !_vm.blogAnswer.accessible
          ? _c("strong", [
              _vm._v(
                "Diary Log entry to this " +
                  _vm._s(_vm._f("customTerm")("Task")) +
                  ":"
              ),
            ])
          : _c("strong", [
              _c("a", { attrs: { href: _vm.blogAnswer.link } }, [
                _vm._v(
                  "Diary Log entry to this " +
                    _vm._s(_vm._f("customTerm")("Task")) +
                    ":"
                ),
              ]),
            ]),
        _vm._v(" "),
        _c("br"),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("br"),
        _vm._v(" "),
        _c(
          "render-quote",
          {
            attrs: {
              "limit-size": true,
              "quote-border-color": _vm.moveAvatarToRight ? "#fff" : undefined,
            },
          },
          [
            _vm.questionPreview
              ? _c("strong", [_vm._v(_vm._s(_vm.questionPreview))])
              : _vm._e(),
            _vm._v(" "),
            _c("diary-location-answer", {
              attrs: { answer: _vm.blogAnswer.data },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _vm.blogAnswer.attachments && _vm.blogAnswer.attachments.length
      ? _c("div", { staticClass: "margin-15-top" }, [
          _c("div", [
            _c("i", { staticClass: "fa fa-paperclip" }),
            _vm._v(
              " Attachments (" +
                _vm._s(_vm.blogAnswer.attachments.length) +
                "):"
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            _vm._l(_vm.blogAnswer.attachments, function (attachment, $index) {
              return _c("media-preview", {
                key: attachment.id,
                staticStyle: {
                  display: "inline-block",
                  "margin-right": "5px",
                  "margin-bottom": "5px",
                },
                attrs: {
                  item: attachment,
                  "no-border": "",
                  "high-light": false,
                },
                nativeOn: {
                  click: function ($event) {
                    return _vm.showAttachments($index)
                  },
                },
              })
            }),
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }